import React from 'react';
import './product-concentration.scss';
import { useIntl } from 'react-intl';
import { walletErDetailPageMessages } from 'azshared';
import { Loader, LoaderSize } from '../../../../../components/loader/loader';
import InfographicPie from '../../../../../components/infographic-pie/infographic-pie';
import { RealEconomyProduct } from 'azshared/build/main/lib/model/wallet/wallet-ow';
interface Props {
  loading: boolean;
  products: RealEconomyProduct[];
}

export const ProductConcentrationChart = (props: Props) => {
  const { formatMessage } = useIntl();

  const { loading, products } = props;

  return (
    <div className='product-concentration'>
      <h4>{formatMessage(walletErDetailPageMessages.productConcentrationTitle)}</h4>
      <div className={'product-concentration-container' + (loading ? '-loader' : '')}>
        {loading && <Loader loadersize={LoaderSize.XL} />}
        {!loading && (
          <InfographicPie
            legend
            biggerActiveItem
            lightTooltip
            legendAlignment={'left'}
            items={products.filter(p=>p.quote !== 0).map((p) => {
              return { value: (p.quote??0)*100, label: p.label };
            })}
          />
        )}
      </div>
    </div>
  );
};
